import * as t from 'io-ts';

export const cargoTrackingResultQuery = t.type({
  trackNos: t.array(t.string),
});

export type CargoTrackingResultQuery = t.TypeOf<typeof cargoTrackingResultQuery>;

export const printCargoTrackingDetails = t.type({
  trackNo: t.string,
});

export type PrintCargoTrackingDetails = t.TypeOf<typeof printCargoTrackingDetails>;
